var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('MainNavBarVue',{attrs:{"showMenu":true}}),_c('v-main',{attrs:{"id":"main"}},[_c('router-view')],1),_c('NotificacoesOperacaoHost'),_c('ErroSistema',{ref:"errorDialog"}),_c('AlertaSistema',{ref:"alertDialog"}),_c('UpdateNotesModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }